module.exports = __webpack_public_path__ + "static/media/castle.55711118.jpg";